import type { Doc } from '@doc';
import type { Nodes } from '@graph';
import type { CommandContext } from './CommandContext';

function selectedGroups(context: CommandContext): Nodes {
  return new Set(Array.from(context.selection.nodes).filter(n => context.doc.isGroup(n)));
}

function deepSelectedGroups(context: CommandContext): Nodes {
  const groups = selectedGroups(context);
  const deepGroups = new Set(groups);
  for (const group of groups) {
    const descendants = Array.from(
      context.doc.graph.forest.transitiveSuccessors(group)
    ).filter(n => context.doc.isGroup(n));
    descendants.forEach(group => deepGroups.add(group));
  }
  return deepGroups;
}

export function collapseGroups(context: CommandContext): { doc: Doc } | undefined {
  const groups = selectedGroups(context);
  if (groups.size === 0) {
    return;
  }

  console.log(
    'collapseGroupsCommand',
    Array.from(groups).map(n => context.doc.nodeTitle(n))
  );

  return undefined;
}

export function deepCollapseGroups(context: CommandContext): { doc: Doc } | undefined {
  const groups = deepSelectedGroups(context);
  if (groups.size === 0) {
    return;
  }

  console.log(
    'deepCollapseGroupsCommand',
    Array.from(groups).map(n => context.doc.nodeTitle(n))
  );

  return undefined;
}

export function expandGroups(context: CommandContext): { doc: Doc } | undefined {
  const groups = selectedGroups(context);
  if (groups.size === 0) {
    return;
  }

  console.log(
    'expandGroupsCommand',
    Array.from(groups).map(n => context.doc.nodeTitle(n))
  );

  return undefined;
}

export function deepExpandGroups(context: CommandContext): { doc: Doc } | undefined {
  const groups = deepSelectedGroups(context);
  if (groups.size === 0) {
    return;
  }

  console.log(
    'deepExpandGroupsCommand',
    Array.from(groups).map(n => context.doc.nodeTitle(n))
  );

  return undefined;
}
